import React, { useEffect } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import axios from "axios";
import { toast } from 'react-toastify';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';

const columns = [
    {
        accessorKey: 'month',
        header: 'Report Date',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    },
    {
        accessorKey: 'download',
        header: 'Report Download',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    }
];


const CurrentMedList = (props) => {

    const [currentmedrpt, setCurrentMed] = useState("");
    const [spinner, showSpinner] = useState(false);
    const [formData, setFormData] = useState({
        reportformat: '5',
        is_print: false,
    });
    const [reportFormat, setReportFormat] = useState('5');
    const [reportDateError, setReportDateError] = useState(false);
    const [reportFormatError, setReportFormatError] = useState(false);
    const [reportdate, setReportDate] = useState(null);
    const [showResults, setShowResults] = React.useState(false)
    const [iframeSrc, setIframeSrc] = useState(null);

    const navigate = useNavigate();


    useEffect(() => {
        if (spinner) {
            setShowResults(false);
        }
    }, [spinner])

    // Handler
    const handleSubmit = async e => {

        e.preventDefault();
        const formatValid = reportFormat !== '';
        setReportFormatError(!formatValid);

        if (!formatValid) {
            return;
        }
        if ((localStorage.getItem("patientId") != null || localStorage.getItem("reportFacilityId") != null) && formData.reportformat != "") {

            showSpinner(true);

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsCurrentMedUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/currentmeds-exp";

            let pelmedsCurrentMedData = localStorage.getItem("reportFacilityId") == null ?
                {
                    patient_id: localStorage.getItem("patientId"),
                    currentmed_format: formData.reportformat,
                    is_print: formData.is_print
                } :
                {
                    facility_id: localStorage.getItem("reportFacilityId"),
                    currentmed_format: formData.reportformat,
                    is_print: formData.is_print
                };

            //console.log("pelmedsCurrentMedData " + JSON.stringify(pelmedsCurrentMedData));

            const data = await axios.post(pelmedsCurrentMedUrl, pelmedsCurrentMedData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            if (data?.data?.status == false) {
                toast.error(data.data.message);
            }
            else {
                toast.success("Discharge Medication Report Generated Successfully");
                const blob = new Blob([data.data], { type: "text/html" });
                const blobUrl = URL.createObjectURL(blob);
                setIframeSrc(blobUrl);
            }

            showSpinner(false);
        }
        else {
            toast.error("Required Fields are empty");
        }

    };

    const handleFieldChange = e => {
        setShowResults(false);
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setReportFormat(e.target.value);
    };

    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <Form.Group>
                            <Row>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_print"
                                        id='is_print'
                                        checked={
                                            formData.is_print
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_print: e.target.checked
                                            })
                                        }
                                        label='Print Medical Record'
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Form.Group>
                            {spinner && (
                                <Button variant="primary" disabled className="mt-1 w-100">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="p-2" style={{ "verticalAlign": "3px" }}>Fetching...</span>
                                </Button>
                            )}
                            {!spinner && (
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="mt-1 w-100">
                                    Generate
                                </Button>
                            )}
                            <div style={{
                                height: 0,
                                overflow: 'hidden',
                                width: 0
                            }}>
                                {iframeSrc && (
                                    <iframe
                                        src={iframeSrc}
                                        style={{ width: "2000px", height: "500px", border: "none" }}
                                        title="Preview Content"
                                    />
                                )}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
            <br />
            {showResults && (
                <a href={currentmedrpt} target="_blank" rel="noreferrer">
                    <button className="btn btn-primary">
                        📄 Download Report
                    </button>
                </a>
            )}
        </div>
    );
};

CurrentMedList.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

CurrentMedList.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default CurrentMedList;
